import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ monitoringManagementKpiId = '', ...data }) => {
  return await dponetAPI.postForm(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics`,
    {
      monitoringManagementKpiMetric: data,
    },
  )
}

const list = async ({ monitoringManagementKpiId = '', ...params }) => {
  return await dponetAPI.get(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics`,
    {
      params,
    },
  )
}

const show = async ({
  monitoringManagementKpiId = '',
  monitoringManagementKpiMetricsId = '',
}) => {
  return await dponetAPI.get(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics/${monitoringManagementKpiMetricsId}`,
  )
}

const update = async ({
  monitoringManagementKpiId = '',
  monitoringManagementKpiMetricsId = '',
  ...params
}) => {
  return await dponetAPI.put(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics/${monitoringManagementKpiMetricsId}`,
    {
      monitoringManagementKpiMetric: params,
    },
  )
}

const addAttachment = async ({
  monitoringManagementKpiId = '',
  monitoringManagementKpiMetricsId = '',
  files = [],
}) => {
  const params = {}
  files.forEach((file, index) => {
    params[`attachment${index}`] = file
  })
  return await dponetAPI.postForm(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics/${monitoringManagementKpiMetricsId}/attachment`,
    params,
  )
}

const destroy = async ({
  monitoringManagementKpiId = '',
  monitoringManagementKpiMetricsId = '',
}) => {
  return await dponetAPI.delete(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics/${monitoringManagementKpiMetricsId}`,
  )
}

const destroyAttachment = async ({
  monitoringManagementKpiId = '',
  monitoringManagementKpiMetricsId = '',
  attachmentId = '',
}) => {
  return await dponetAPI.delete(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/metrics/${monitoringManagementKpiMetricsId}/attachment/${attachmentId}`,
  )
}

export default {
  addAttachment,
  create,
  destroy,
  destroyAttachment,
  list,
  show,
  update,
}
